import { IFilterObj } from 'src/components/filters/models/filter-response.model';

// eslint-disable-next-line no-shadow
enum DRAWER_VIEW_TYPE {
  PPG,
  SKU,
  COMMENTS,
  TABLE_COMMENT_BOX,
  PRODUCT_DETAILS
}

export default DRAWER_VIEW_TYPE;

export interface IDrawerPayload {
  toggle: string;
  filter_inputs: IFilterObj[];
}

// interface for adding new comment payload
export interface IAddCommentPayload {
  params: {
    comment_text: string;
    filter_inputs?: IFilterObj[];
    productMapping?: { [key: string]: unknown };
    [key: string]: unknown;
  };
}
